import { render, staticRenderFns } from "./annualAverage.vue?vue&type=template&id=5c7de156&scoped=true&"
import script from "./annualAverage.vue?vue&type=script&lang=js&"
export * from "./annualAverage.vue?vue&type=script&lang=js&"
import style0 from "./annualAverage.vue?vue&type=style&index=0&id=5c7de156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7de156",
  null
  
)

export default component.exports